import { render } from "./PoliticasInternas.vue?vue&type=template&id=aea35512"
import script from "./PoliticasInternas.vue?vue&type=script&lang=js"
export * from "./PoliticasInternas.vue?vue&type=script&lang=js"

import "./PoliticasInternas.vue?vue&type=style&index=0&id=aea35512&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__